import React from "react";
import { Typography, Button, Dialog, DialogContent, DialogActions } from "@mui/material";

import theme from "../theme";

interface DialogBoxBiometricSuccessProps {
  open: boolean;
  /** Display label of the biometric method, e.g. "Face ID" or "Biometrics". */
  methodName: string;
  onClose: () => void;
}

const createStyles = () => ({
  header: {
    color: theme.palette.primary.main,
    marginBottom: "10px",
  },
  dialogBox: {
    width: "380px",
  },
});

/**
 * Confirmation shown after a device is successfully enrolled for biometric
 * (Face ID / fingerprint) sign-in, reassuring the user that the next login can
 * use biometrics.
 */
const DialogBoxBiometricSuccess: React.FC<DialogBoxBiometricSuccessProps> = (props) => {
  const classes = createStyles();
  const trailingText = props.methodName.toLowerCase().includes("fingerprint") ? " Unlock" : "";

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth={"md"}
      aria-labelledby="biometric-success-dialog-title"
      sx={{ paper: classes.dialogBox }}
    >
      <DialogContent>
        <Typography variant="h4" sx={classes.header}>
          Success
        </Typography>
        <Typography>Next time, you&apos;ll be able to log in using {props.methodName} {trailingText}</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={props.onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogBoxBiometricSuccess;
